<template>
	<div data-tour-scope="newsletters-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.newsletters') }} </v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="export">
											<v-icon>mdi-arrow-collapse-down</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item data-tour="export-csv" @click="exportAsync('newsletters', 'csv', { search: searchfield })">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Esporta in CSV</v-list-item-title>
											</v-list-item-content>
										</v-list-item>

										<v-list-item @click="exportAsync('newsletters', 'excel', { search: searchfield })">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Esporta in Excel</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!-- <v-divider vertical></v-divider>-->
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi iscritto" data-tour="add-email" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
							</v-row>
						</v-col>
						<v-card v-if="selected.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selected.length }}
									<span v-if="selected.length == 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="editItem(null)" v-if="selected.length == 1"> modifica </v-tab>
								<!-- <v-tab @click="duplicateItem" v-if="selected.length==1">
                                     duplica
                                 </v-tab>-->
								<v-tab @click="deleteItem"> elimina </v-tab>
								<!--<v-tab  :href="this.getUrl+'items/download?token='+this.getToken+'&search='+this.searchfield+'&filters='+this.settings.filters+'&selected='+this.selected">
                                    Download
                                </v-tab>-->
							</v-tabs>
						</v-card>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
						 class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"
                            :class="{mobile: isMobile}"-->

							<!-- <template slot="headers" slot-scope="props">
                                 <tr>
                                     <th>
                                         <v-checkbox
                                                 primary
                                                 hide-details
                                                 @click.native="toggleAll"
                                                 :input-value="props.all"
                                                 :indeterminate="props.indeterminate"
                                         ></v-checkbox>
                                     </th>
                                     <th v-for="header in props.headers" :key="header.text"
                                         :class="['column sortable', settings.pagination.descending ? 'desc' : 'asc', header.value === settings.pagination.pagination.sortBy ? 'active' : '']"
                                         @click="changeSort(header.value)"
                                     >
                                         <v-icon>arrow_upward</v-icon>
                                         {{ header.text }} f
                                     </th>
                                 </tr>
                             </template>-->
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="newsletter-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="titoloCard(item)" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
																<v-icon dark> mdi-dots-vertical </v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Attivo</span>
													<v-switch v-model="item.active" data-tour="status" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="`${item._id}${_.random(1, 10000)}`">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->

										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
											<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
											<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
									<v-switch v-model="item.active" data-tour="status" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
										<td>
											{{ item.id }}
										</td>
										<td>
											{{ item.created_at | moment('DD/MM/YYYY') }}
										</td>

										<td>
											{{ item.registration_at | moment('DD/MM/YYYY') }}
										</td>
										<td>
											{{ item.name }}
										</td>
										<td>
											{{ item.lastname }}
										</td>
										<td>
											{{ item.email }}
										</td>
										<td>{{ item.phone }}</td>

										<td>{{ item.ip }}</td>
										<td>{{ item.user_agent }}</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando la categoria non potrai più ripristinarla. I prodotti associati resteranno senza categoria </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';

Vue.use(VuetifyDraggableTreeview);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { createNewslettersTourSteps, stopNewslettersTour } from './newsletters-tour';


// sotto i 4 caratteri il backend ignora la ricerca
const SEARCH_MIN = 4;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	// pagina, righe, ordinamento e ricerca stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	name: 'Items',
	setup() {
		return { tour: useTour(createNewslettersTourSteps(), { onStop: stopNewslettersTour }) };
	},
	data() {
		return {
			menu: false,
			customersType: [
				{ name: 'Private', value: 'private' },
				{ name: 'Company', value: 'company' },
			],
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,
			searchfield: '',
			selected: [],
			total: 0,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Active', value: 'active', sortable: true },
				{ text: 'Id', value: 'id', sortable: false },
				{ text: 'Created', value: 'created_at', sortable: true },
				{ text: 'Registrated', value: 'registration_at', sortable: true },
				{ text: 'Name', value: 'name', sortable: true },
				{ text: 'Lastname', value: 'lastname', sortable: true },
				{ text: 'Email', value: 'email', sortable: true },
				{ text: 'Phone', value: 'phone', sortable: true },
				{ text: 'Ip', value: 'ip' },
				{ text: 'User agent', value: 'user_agent' },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			langDefault: '',
			brands: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			selectListings: [],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return (value = value.toFixed(2));
		},
	},
	created() {
		this.setExistFilter(true);
		this.listLoad();

		this.fetchSetting().then(data => {
			this.langDefault = _.find(data.languages, { default: true }).lang;
		});
	},
	watch: {
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		TourOverlay,
		KeyValueCard,

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'newsletters/getIndex',
			getItems: 'newsletters/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'newsletters/getSortBy',
			getSortDesc: 'newsletters/getSortDesc',
			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function (old, newvalue) {
				return this.clippedOrder;
			},
			set: function (newvalue) {
				return this.clippedOrder;
			},
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'newsletters/setItems',
			setItem: 'newsletters/setItem',
			setIndex: 'newsletters/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'newsletters/asyncFetchData',

			deleteItems: 'newsletters/deleteItem',
			destroyData: 'newsletters/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			getListings: 'listings/getListings',

			//'resetMessages' : 'settings/resetMessages'
		}),

		// titolo della card: nome e cognome, altrimenti l'email
		titoloCard(item) {
			const nome = `${item.name || ''} ${item.lastname || ''}`.trim();
			return nome || item.email || '';
		},
		// coppie chiave/valore della card (vista telefono)
		campiCard(item) {
			const data = v => (v ? this.$moment(v).format('DD/MM/YYYY') : '');
			return [
				{ label: 'Email', value: item.email, strong: true },
				{ label: 'Id', value: item.id },
				{ label: 'Created', value: data(item.created_at) },
				{ label: 'Registrated', value: data(item.registration_at) },
				{ label: 'Phone', value: item.phone },
				{ label: 'Ip', value: item.ip },
				{ label: 'User agent', value: item.user_agent },
			];
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		// inserimento e modifica sono pagine (si apre solo dalla riga, tre puntini):
		// la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/newsletters/${item._id}`);
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/newsletters/new');
		},
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		convertListing(_id) {
			if (_id != '') {
				var check = _.find(this.selectListings, { _id: _id });
				if (check) {
					return check.name;
				} else {
					return '';
				}
			}
		},

		async changeStatus(item) {
			try {
				this.setPreload(true);
				let url = 'newsletters/status';
				axios
					.patch(`${this.getUrl}${url}`, { _id: item._id, active: item.active }, { headers: { Authorization: `Bearer ${this.getToken}` } })
					.then(({ data }) => {
						if (data.data._id) {
							this.snackbar.color = 'success';
							this.snackbar.text = 'Update successfully';
							this.snackbar.snackbar = true;
							this.snackbar.mode = 'multi-line';
							this.snackbar.timeout = 5000;
						}
						this.getDataFromApi();
					})
					.catch(err => {
						if (err.response) {
							let errors = err.response.data.error;
							if (errors) {
								console.log(errors);

								var testo = '';
								errors.forEach(value => {
									//   console.log(value.msg);
									var spliterror = _.split(value.param, '.');
									this.messages[spliterror[1]] = value.msg;
									testo += value.msg + ' <br>';
								});
							}

							this.snackbar.color = 'error';
							//this.snackbar.text = this.$vuetify.lang.t(`$vuetify.errors.${err.response.data.message}`);
							this.snackbar.text = testo;
							this.snackbar.snackbar = true;
							this.snackbar.mode = 'multi-line';
							this.snackbar.timeout = 5000;
							this.setPreload(false);
							if (err.response.status === 401) {
								this.setLogout();
								this.$router.push('/login');
							}
						}
					});

				this.setPreload(false);
			} catch (e) {
				console.log(e.message);
			}
		},

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;

				const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;

				let items = this.fetchItems(this.settings);
				items
					.then(result => {
						this.total = result.total;
						//this.items = result.data.data
						this.setPreload(false);
						this.selected = [];
					})
					.then(() => {
						/*this.getFetchTreeCategory().then(() => {

                            var find =  _.orderBy(this.getCategoriesTree, 'parent.id', 'asc');

                            if(_.size(find)>0) {
                                if (_.size(find) > 1) {
                                    this.firstLevel = _.filter(this.getCategoriesTree, filter => {
                                        return filter.parent.id == find[0].parent.id
                                    })
                                    // console.log(this.firstLevel)
                                }

                                this.getNestedCategory(find[0].parent.id).then(() => {

                                    this.items = this.getCategoriesChildrean
                                })
                            }


                        })*/
					});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},

		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},

		confirmDelete() {
			this.dialogconfirm = false;

			this.messages = [];

			this.deleteItems(this.form)
				.then(data => {
					this.setPreload(false);
					this.getDataFromApi().then(res => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style></style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.newsletter-cards,
.newsletter-cards tr {
	display: block;
	width: 100%;
}
.newsletter-cards tr,
.newsletter-cards tr:hover {
	background: transparent !important;
}
.newsletter-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.newsletter-cards tr:first-child td {
	padding-top: 12px !important;
}
.newsletter-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.newsletter-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
